import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './tailwind.css';
import './styles.scss';
import App from './App';
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const enabled = import.meta.env.VITE_SENTRY_ENABLED === 'true';

if (enabled && dsn) {
  try {
    const environment =
      (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) || import.meta.env.MODE || 'development';

    Sentry.init({
      dsn,
      environment,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^https?:\/\/yourserver\.io\/api/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      enableLogs: true,
    });
    console.log(`[sentry] Inicializado — entorno: ${environment}`);
  } catch {
    console.warn('[sentry] Error al inicializar Sentry');
  }
} else {
  console.log('[sentry] Sentry deshabilitado — definir VITE_SENTRY_ENABLED=true y VITE_SENTRY_DSN para activar');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
